import React from 'react'
import { NAV } from '../../../../Config/Routing/nav'
import { PATHS } from '../../../../Config/Routing/paths'
import { PageNav, PageNavItem } from '../../../../Components/PageNav'
import { authorization as auth } from '../../../../Module/Auth/Auth'
import { DE_COUNTRY_ID, COUNTRY_CODE } from '../../../../constants'

const INVOICE_COUNTRIES = [COUNTRY_CODE.UNITED_STATES, COUNTRY_CODE.CANADA]

const CountryHeaderNav = ({ history, countryId, countryCode }) => {
  const BASE_URL =
    PATHS.main.dashboard + PATHS.dashboard.countries + '/' + countryId + '/'

  const isGermany = countryId == DE_COUNTRY_ID
  const showInvoices = INVOICE_COUNTRIES.includes(countryCode)

  return (
    <PageNav history={history}>
      {auth.isAdmin() || auth.isCityManager() ? (
        <PageNavItem href={BASE_URL + NAV.COUNTRY_HEADER_NAV.GLOBAL_PLANING}>
          Global Planning
        </PageNavItem>
      ) : null}
      {auth.isAdmin() || auth.isCityManager() ? (
        <PageNavItem href={BASE_URL + NAV.COUNTRY_HEADER_NAV.PIPELINE}>
          Campaign Pipeline
        </PageNavItem>
      ) : null}
      {auth.isAdmin() || auth.isCityManager() ? (
        <PageNavItem href={BASE_URL + NAV.COUNTRY_HEADER_NAV.SETTINGS}>
          Self-Serve Settings
        </PageNavItem>
      ) : null}
      {auth.isAdmin() && isGermany ? (
        <PageNavItem href={BASE_URL + NAV.COUNTRY_HEADER_NAV.BA_PAYSLIP}>
          BA Document Uploads
        </PageNavItem>
      ) : null}
      <PageNavItem href={BASE_URL + NAV.COUNTRY_HEADER_NAV.WEATHER}>
        Weather
      </PageNavItem>
      {auth.isAdmin() || auth.isCityManager() ? (
        <PageNavItem href={BASE_URL + NAV.COUNTRY_HEADER_NAV.CHANNELS}>
          Found us via
        </PageNavItem>
      ) : null}
      {auth.isAdmin() || auth.isCityManager() ? (
        <PageNavItem
          href={BASE_URL + NAV.COUNTRY_HEADER_NAV.PROJECT_MANAGEMENT}
        >
          Project Management
        </PageNavItem>
      ) : null}

      {auth.isAdmin() && showInvoices ? (
        <PageNavItem href={BASE_URL + NAV.COUNTRY_HEADER_NAV.INVOICES}>
          Invoices
        </PageNavItem>
      ) : null}
    </PageNav>
  )
}

export { CountryHeaderNav }
